import React from 'react';
import { Link } from "gatsby"

const FeaturedService = () => {
    return (
        <div className="boxes-area pb-70">
            <div className="container">
            <div className="row d-flex justify-content-center text-center">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                    <Link to="/ai-in-conversations">
                        <div className="single-boxes-box">
                            <div className="icon">
                              <i className="bx bx-chat"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/ai-in-conversations">
                                    Conversational AI
                                </Link>
                            </h3>
                            <p>Drive Conversions on WhatsApp with AI</p>

                            <Link to="/ai-in-conversations" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                    <Link to="/marketing-ai">
                        <div className="single-boxes-box">
                            <div className="icon">
                                <i className="bx bx-atom"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/marketing-ai">
                                Marketing AI
                                </Link>
                            </h3>
                            <p>Maximize your marketing efforts with AI</p>
                            
                            <Link to="/marketing-ai" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>
                    </div>
            </div>    
                <div className="row d-flex justify-content-center text-center">
                    <div className="col-lg-5 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                    <Link to="/manufacturing-ai">
                     <div className="single-boxes-box">
                            <div className="icon">
                                <i className="bx bx-wrench"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/manufacturing-ai">
                                Manufacturing AI
                                </Link>
                            </h3>
                            <p>Improve efficiency and profitability with AI</p>
                            
                            <Link to="/manufacturing-ai" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-6">
                    <Link to="/sports-and-fitness-ai">
                        <div className="single-boxes-box">
                            <div className="icon">
                                <i className="bx bx-run"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/sports-and-fitness-ai">
                                    Sports & Fitness AI
                                </Link>
                            </h3>
                            <p>Level up training & performance with AI</p>

                            <Link to="/sports-and-fitness-ai" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeaturedService;